import { Container } from "@mui/material";
import React from "react";
import Availible from "../../../Components/Availible";
import { SectionHeading, SectionWrapper } from "../../../Styles/style";
import S9_Footer from "../../Main/S9_Footer";
import Accordian from "./Components/Accordian";
const S3_Faq = () => {
  return (
    <div>
      <SectionWrapper p="4rem 0">
        <Container
          maxWidth="xl"
          data-aos="fade-up"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000"
        >
          <SectionHeading align="center" data-aos="zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="1000">FAQ</SectionHeading>
          <Accordian />
        </Container>
      </SectionWrapper>
      <Availible />
      <S9_Footer />
    </div>
  );
};

export default S3_Faq;
